export * from './Heading'
export * from './Paragraph'
// eslint-disable-next-line import/export
export * from './Text'
